import styled from 'styled-components';

export const StyledSplash = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
`;
